import useToast from '@fuse/hooks/useToast'
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Dialog,
	DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Icon,
	IconButton, InputLabel, makeStyles, MenuItem, Paper, Select, TextField, Tooltip, Typography,
	Drawer,TextareaAutosize 
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeFormViewerDialog } from '../store/formViewDialogReducer'
import axios from '@fuse/utils/axios'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { Autocomplete } from '@material-ui/lab'
import { openFormViewerDialog,setFromData } from '../store/formViewDialogReducer';
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort'
import AddCategoryDialog from '@fuse/components/Modal/QuickAddCategory'
import ManufacturerDialog from '@fuse/components/Modal/QuickAddManufacturer'
import AddModelAttributeDialog from '@fuse/components/Modal/QuickAddModelAttribute'
import { generateRandomNumberString } from '@fuse/utils/stringOperations'

const useStyles = makeStyles(theme => ({
	uploadImageButton: {
		padding: '6px 16px',
		fontSize: '1.3rem',
		minWidth: '64px',
		boxSizing: 'border-box',
		transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		fontFamily: 'Inter, sans-serif',
		fontWeight: 500,
		lineHeight: 1.75,
		borderRadius: '4px',
		textTransform: 'none',
		backgroundColor: '#6B2C57',
		color: '#ffffff',
		cursor: 'pointer'
	},
	loader: {
	display: 'flex',
	'& > * + *': {
		marginLeft: theme.spacing(2),
	},
	},
	subSection: {
		marginLeft:'20px',
		marginRight:'20px',
		marginBottom:'20px',
		padding: '10px', 
		backgroundColor: '#f4f4f4', 
		borderRadius:'4px'
	},
	endButtons: {
			borderRadius: '4px'
	},
	drawerWidth: {
		width: 600
	},
	textarea: {
		resize: "both",
		width: "100%"
	},
}))

function AddModelDialog(props) {
	const classes = useStyles()
	const dispatch = useDispatch()
	const toast = useToast(dispatch)
	const openState = useSelector((state) => state.slaApp.formViewDialog)
	const { data:editFromState } = useSelector(({slaApp}) => slaApp.formViewDialog);
	const [loading, setLoading] = useState(false)

	//form validation
	const schema = yup.object({
		sla_name: yup.string().required('Service Level Agreement name is required!'),
		description: yup.string()
	})

	const defaultValues = {
		sla_name: '',
		description: ''
	}

	const onSuccess = () => {
		reset(defaultValues)
		dispatch(setFromData(null))
		closeDialog()
	}

	const closeDialog = () => {
		dispatch(closeFormViewerDialog())
	}

	const { control, formState, handleSubmit, reset, setValue } = useForm({
		mode: 'onChange',
		defaultValues,
		resolver: yupResolver(schema)
	});

	useEffect(()=>{
		if(editFromState){
			setValue('sla_name', editFromState.service_level_agreement_name)
			setValue('description', editFromState.description)
		}
	},[editFromState])

  const { errors } = formState

	const manageFormData = (formData) => {

		let payload = {
			sla: formData.sla_name,
			description: formData.description
		}
		
		if(!editFromState){
			payload = {
				...payload,
				entity_external_platform_id: generateRandomNumberString(),
			}

			axios.post('/service-level-agreement/add', payload).then(response => {
				if(response.status == 201){
					toast.error(response.data.message)
				} else {
					onSuccess()
					toast.success('Service Level Agreement added successfully.')
					props.getServiceLevelAgreements()
				}
			}).catch(err => {
				console.log('212=>',err);
				toast.error('Something went wrong!')
			})

		}else{
			payload = {
				...payload,
				id: editFromState.id,
			}

			axios.put('/service-level-agreement/update', payload).then(response => {
				if(response.status == 201){
					toast.error(response.data.message)
				} else {
					onSuccess()
					toast.success('Service Level Agreement updated successfully.')
					props.getServiceLevelAgreements()
				}
			}).catch(err => {
				console.log('212=>',err);
				toast.error('Something went wrong!')
			})

		}
		
	}

	const errorData = (error) => {
		console.log('363=>',error)
	}
	
	return (
		<div>
			
			<Drawer anchor='right' open={openState.open} classes={{ paper: classes.drawerWidth }}>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>  
					<DialogTitle>{ Boolean(editFromState) ? 'Update Service Level Agreement' : 'Add Service Level Agreement'}</DialogTitle>
					<IconButton style={{marginRight: '15px'}} onClick={ onSuccess }>
						<Icon>close</Icon>
					</IconButton>
				</div>

				<form onSubmit={ handleSubmit(manageFormData, errorData) }>

				{/*----------------------Item Information------------------------- */}
					
					<div className={classes.subSection}>
						<div style={{ width: '100%' }}>
						<Typography style={{fontSize:'16px'}}>Required Information *</Typography>
							<Divider style={{marginBottom: '10px'}}/>
						</div>

						<div >
							<div style={{ borderRadius:9, padding: '0', width:'100%', marginBottom: '10px'}}>
								<Controller 
									name='sla_name'
									control={control}
									render={({field}) => (
										<TextField
											{...field}
											variant='outlined'
											label="Service Level Agreement*"
											fullWidth
											style={{ width: '100%', backgroundColor: '#fff' }}
											error={!!errors.sla_name}
											helperText={errors?.sla_name?.message}
											FormHelperTextProps={{
												style: { 
													margin : 0, 
													backgroundColor: '#f4f4f4',
													width: '100%',
													paddingTop: '2px'
												}
											}}
										/>
									)}
								/>
							
							</div>

							<div style={{ borderRadius:9, padding: '0', width:'100%'}}>
								<Controller 
									name='description'
									control={control}
									render={({field}) => (
										<TextField
											{...field}
											variant='outlined'
											label="Description"
											fullWidth
											multiline
											rows={8}
											style={{ width: '100%', backgroundColor: '#fff' }}
											error={!!errors.description}
											helperText={errors?.description?.message}
											inputProps={{ className: classes.textarea }}
											FormHelperTextProps={{
												style: { 
													margin : 0, 
													backgroundColor: '#f4f4f4',
													width: '100%',
													paddingTop: '2px'
												}
											}}
										/>
									)}
								/>
							
							</div>
						</div>
					</div>
					<div style={{padding:0, margin:20 ,display:'flex', justifyContent:'left'}}>
						<Button className={classes.endButtons} style={{marginRight: '10px'}} type='submit' variant='contained' color='primary' /*disabled={Object.keys(errors).length !== 0}*/>{editFromState ? 'Update' : 'Add'}</Button>
						<Button className={classes.endButtons}  variant='outlined' color='primary' onClick={ onSuccess }>Cancel</Button>
					</div>						
				</form>        
			</Drawer>
		</div>
	)
}

export default AddModelDialog
